import React from "react";
import "./fullPageLoader.css";

const FullPageLoader = ({ position = "fixed", label = "Loading" }) => {
  return (
    <div className={`alg-loader-overlay alg-loader-${position}`}>
      <div className="alg-loader-mark">
        <span className="alg-loader-pulse-ring" />
        <span className="alg-loader-pulse-ring" />
        <span className="alg-loader-pulse-ring" />
        <span className="alg-loader-core" />
      </div>
      <div className="alg-loader-label">
        {label}
        <span className="alg-loader-dots">
          <i></i>
          <i></i>
          <i></i>
        </span>
      </div>
    </div>
  );
};

export default FullPageLoader;
